import axios from 'axios';
import { API_URL } from '../Auth/constansts';

const SetGreenhouseCreate = async (
    token,
    companyid,
    name,
    address,
    phone,
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            name +
            address +
            phone + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/setgreenhouse`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                name: name,
                address: address,
                phone: phone,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200 || data.status === 201) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const SetGreenhouseEdit = async (
    token,
    companyid,
    greenhouseid,
    name,
    address,
    phone,
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            greenhouseid +
            name +
            address +
            phone + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/editgreenhouse`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenhouseid:greenhouseid,
                name: name,
                address: address,
                phone: phone,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200 || data.status === 201) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const ListGreenHousesDataAPI = async (token, companyid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/getgreenhouses`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const GetGreenHouseDataAPI = async (token, companyid, greenhouseid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/getgreenhouse`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenhouseid:greenhouseid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}


const SetGreenmoduleCreate = async (
    token,
    companyid,
    greenhouseid,
    name,
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            greenhouseid +
            name + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/setgreenmodule`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenhouseid:greenhouseid,
                name: name,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200 || data.status === 201) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const ListGreenmodules = async (token, companyid, greenhouseid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/getgreenmodules`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenhouseid: greenhouseid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}


const DataGreenmodules = async (token, companyid, greenmoduleid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/getgreenmodule`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenmoduleid: greenmoduleid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}



const SetTermometerCreate = async (
    token,
    companyid,
    greenmoduleid,
    inuse,
    mac,
    serial
) => {
    try {
        const time = new Date().valueOf();
        const message = "@" + time + "#" + companyid +
            greenmoduleid +
            inuse + 
            mac +
            serial + "@";
        const encoder = new TextEncoder();
        const datas = encoder.encode(message);
        const digest = await crypto.subtle.digest("SHA-512", datas);
        const hashArray = Array.from(new Uint8Array(digest)); // convert buffer to byte array
        const hashHex = hashArray
            .map((b) => b.toString(16).padStart(2, "0"))
            .join(""); // convert bytes to hex string
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/settermometer`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenmoduleid:greenmoduleid,
                inuse: inuse,
                mac:mac,
                serial:serial,
                timestamp: time,
                signature: hashHex
            }
        };
        const data = await axios.request(config);
        if (data.status === 200 || data.status === 201) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return error;
    }
}

const ListTermometers = async (token, companyid, greenmoduleid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/gettermometers`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                greenmoduleid: greenmoduleid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const DataTermometer = async (token, companyid, termometerid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/gettermometerchart`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                termometerid: termometerid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const DatosTermometer = async (token, companyid, termometerid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/gettermometer`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                termometerid: termometerid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

const DatosConfTermometer = async (token, companyid, termometerid) => {
    try {
        const config = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${API_URL}/greenhouse/gettermometerConf`,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            data: {
                companyid: companyid,
                termometerid: termometerid
            }
        };
        const data = await axios.request(config);
        if (data.status === 200) {
            return data.data;
        }
        else {
            return 201;
        }
    } catch (error) {
        return 500;
    }
}

export {
    SetGreenhouseCreate,
    SetGreenhouseEdit,
    ListGreenHousesDataAPI,
    GetGreenHouseDataAPI,

    SetGreenmoduleCreate,
    ListGreenmodules,
    DataGreenmodules,

    DatosTermometer,
    SetTermometerCreate,
    DatosConfTermometer,
    ListTermometers,
    DataTermometer,
}